import { useNavigate } from "react-router-dom";
import RevAudTable from "src/components/pages/Summary/ReviewsAndAudits/RevAudTable";
import useGetRevAud from "src/components/pages/Summary/ReviewsAndAudits/useGetRevAud";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { useIsOnline } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import { ButtonsWrapper, PageContainer } from "src/styled";

const Audits = () => {
  const navigate = useNavigate();
  const isOnline = useIsOnline();
  const yachtuser = useSelector(state => state.permsSlice.yachtuser);

  const { data, isLoading, refetch } = useGetRevAud("get-reviews-flag");
  return (
    <PageContainer>
      <Breadcrumbs
        customLinks={!yachtuser ? links => links.slice(2) : undefined}
        border={false}>
        {yachtuser && (
          <ButtonsWrapper>
            <Button onClick={() => navigate("/summary/audits/review-comments")}>
              Review Comments
            </Button>
            <Button
              onClick={() => navigate("/summary/audits/create-audit")}
              disabled={!isOnline}>
              Create
            </Button>
          </ButtonsWrapper>
        )}
      </Breadcrumbs>
      <RevAudTable data={data ?? []} loading={isLoading} refetch={refetch} />
    </PageContainer>
  );
};

export default Audits;
